export default "__VITE_ASSET__95877a44__"